/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum LineItemState {
    UNDEFINED_STATE = 'UNDEFINED_STATE',
    ALLOCATED = 'ALLOCATED',
    PROPOSED = 'PROPOSED',
    CONFIRMED = 'CONFIRMED',
    DECLINED = 'DECLINED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    RETURNING = 'RETURNING',
    RETURNED = 'RETURNED',
    NOT_RECEIVED = 'NOT_RECEIVED',
}
